import React from "react";
import { Navigate } from "react-router";
import Base from "../Base";
import SelectAsync from "react-select/async";
import DatePicker from 'react-datepicker2';
import Leave from "../Leaves/Leave";
import Form from "../Secretariat/Form";

export default class Letter extends Base {
    constructor(props) {
        super(props);
        this.state = {
            id: this.isNull(props.Id) ? this.defaultGuid() : props.Id,
            source: this.isNull(props.Source) ? 1 : props.Source,
            formType: this.isNull(props.FormType) ? 0 : props.FormType,
            refreshCallerAfterSave: this.isNull(props.RefreshCallerAfterSave) ? true : props.RefreshCallerAfterSave,
            caller: props.Caller,
            callerSection: props.CallerSection,
            refId: this.isNull(props.RefId) ? this.defaultGuid() : props.RefId,
            data: null,
            loading: true,
            andikators: [],
            initPerson: this.isNull(props.InitPerson) ? null : props.InitPerson,
            note: '',
            content: '',
            toPersonIds: [],
            uiSettings: this.getUiSettings(),
        };
        this.keyDownFunction = this.keyDownFunction.bind(this);
    }
    componentWillUnmount() {
        this.removeKeyDown();
    }
    componentDidMount() {
        this.addKeyDown();
        this.getUiSettingConfigs({ formName: 'letter' });

        var p1 = this.httpPost("api/v1/letter/get", {
            id: this.state.id,
            formType: this.state.formType,
            callerSection: this.state.callerSection
        })
            .then((data) => {
                if (data.status === -1) window.location.href = "/login";
                if (data.status === 1) {
                    this.state.data = data;
                    this.loadAndikators(data.record.type);
                    if (this.state.id === this.getDefaultGuid()) {
                        if (!this.isNull(this.state.initPerson)) {
                            if (this.state.callerSection === 'out') {
                                this.state.data.record.toPersonId = this.state.initPerson.id;
                                this.state.data.record.toPersonString = this.state.initPerson.name;
                            }
                            if (this.state.callerSection === 'in') {
                                this.state.data.record.fromPersonId = this.state.initPerson.id;
                                this.state.data.record.fromPersonString = this.state.initPerson.name;
                            }
                        }
                    }
                }
            });
        Promise.all([p1]).then((r) => {
            this.setState({
                loading: false,
            });
        });
    }
    loadAndikators(type) {
        fetch("/api/v1/andikator/list/", {
            method: "post",
            body: JSON.stringify({
                filters: {
                    title: "",
                    type
                }
            }),
            headers: {
                "Content-Type": "application/json",
            },
        })
            .then((response) => response.json())
            .then((response) => {
                let items = [];
                if (response.status == 1) {
                    response.records.map((_record) =>
                        items.push({
                            value: _record.id,
                            label: _record.title,
                            lastNumber: _record.lastNumber,
                            postfix: _record.postfix,
                            prefix: _record.prefix,
                        })
                    );
                }
                this.setState({
                    andikators: items,
                });
            });
    }
    setAndikator(e) {
        this.state.data.record.andikatorId = e;
        this.state.data.record.andikatorPostfix = '';
        this.state.data.record.andikatorPrefix = '';

        this.state.andikators.forEach(item => {
            if (e == item.value) {
                if (this.state.data.record.number == "0" || this.isBlank(this.state.data.record.number)) {
                    this.state.data.record.number = item.lastNumber;
                }
                this.state.data.record.andikatorPostfix = item.postfix;
                this.state.data.record.andikatorPrefix = item.prefix;
            }
        });

        this.setState({
            data: this.state.data,
        });
    }
    setFromPerson(e) {
        this.state.data.record.fromPersonId = e.value;
    }
    setToPerson(e) {
        this.state.data.record.toPersonId = e.value;
    }
    setSignPerson(e) {
        this.state.data.record.signPersonId = e.value;
    }
    setTranscriptRecipients(e) {
        this.state.data.record.transcriptRecipients = e;
    }
    save(e, status) {
        if (!this.isNull(e)) e.preventDefault();

        var leaveRequest = null;
        if (this.state.source === 2) {
            leaveRequest = {
                status: this.state.data.record.leaveRequest.status,
                type: this.state.data.record.leaveRequest.type,
                fromDate: this.convertMomentToDb(this.state.data.record.leaveRequest.fromDate),
                toDate: this.convertMomentToDb(this.state.data.record.leaveRequest.toDate),
                fromTime: this.state.data.record.leaveRequest.fromTime != "" ? parseInt(this.state.data.record.leaveRequest.fromTime) : 0,
                toTime: this.state.data.record.leaveRequest.toTime != "" ? parseInt(this.state.data.record.leaveRequest.toTime) : 0,
                durationType: this.state.data.record.leaveRequest.durationType
            }
        }
        var formRequest = null;
        if (this.state.source === 3) {
            if (this.isBlank(this.state.data.record.formRequest.price)) this.state.data.record.formRequest.price = 0;
            formRequest = {
                status: this.state.data.record.formRequest.status,
                type: this.state.data.record.formRequest.type,
                car: this.state.data.record.formRequest.car,
                carNo: this.state.data.record.formRequest.carNo,
                description: this.state.data.record.formRequest.description,
                notic: this.state.data.record.formRequest.notic,
                price: this.state.data.record.formRequest.price,
                fromDate: this.convertMomentToDb(this.state.data.record.formRequest.fromDate),
                toDate: this.convertMomentToDb(this.state.data.record.formRequest.toDate),
                fromTime: this.state.data.record.formRequest.fromTime != "" ? parseInt(this.state.data.record.formRequest.fromTime) : 0,
                toTime: this.state.data.record.formRequest.toTime != "" ? parseInt(this.state.data.record.formRequest.toTime) : 0,
            }
        }

        if (this.isBlank(this.state.data.record.number)) this.state.data.record.number = 0;

        this.httpPost("api/v1/letter/save", {
            id: this.state.id,
            status: status,
            source: this.state.source,
            leaveRequest: leaveRequest,
            formRequest: formRequest,
            number: parseInt(this.state.data.record.number),
            subject: this.state.data.record.subject,
            fromPersonId: this.state.data.record.fromPersonId,
            transcriptRecipients: this.state.data.record.transcriptRecipients,
            type: this.state.data.record.type,
            content: this.state.data.record.content,
            andikatorId: this.state.data.record.andikatorId,
            date: this.convertMomentToDb(this.state.data.record.date),
            replyDeadline: this.convertMomentToDb(this.state.data.record.replyDeadline),
            needReply: this.state.data.record.needReply,
            toPersonId: this.state.data.record.toPersonId,
            signPersonId: this.state.data.record.signPersonId,
            note: this.state.data.record.note,
            channel: this.state.data.record.channel,
            refId: this.state.refId,
            attachments: this.state.data.record.attachments,

        }).then((data) => {
            if (data.status === -1) window.location.href = "/login";
            this.state.innerStatus = data.innerStatus;
            if (data.status === 1) {
                this.showSuccessMessage("اطلاعات با موفقیت ذخیره شد");
                if (this.state.refreshCallerAfterSave)
                    this.state.caller.refreshData();
                this.closeMe();
            } else {
                this.showErorrMessage(data.message);
                this.setState({
                    loading: false,
                });
            }
        });
    }
    sign(e) {
        if (!this.isNull(e)) e.preventDefault();

        this.httpPost("api/v1/letter/sign", {
            id: this.state.id,

        }).then((data) => {
            if (data.status === -1) window.location.href = "/login";
            this.state.innerStatus = data.innerStatus;
            if (data.status === 1) {
                this.showSuccessMessage("امضا نامه با موفقیت انجام پذیرفت");
                if (this.state.refreshCallerAfterSave)
                    this.state.caller.refreshData();
                this.closeMe();
            } else {
                this.showErorrMessage(data.message);
                this.setState({
                    loading: false,
                });
            }
        });
    }
    asign(e) {
        if (!this.isNull(e)) e.preventDefault();

        //جهت برگشت به تب اول
        var letterInfoTab = document.getElementById("letterInfoTab");
        if (letterInfoTab) letterInfoTab.click();

        this.httpPost("api/v1/letter/asign", {
            id: this.state.id,
            note: this.state.note,
            content: this.state.content,
            toPersonIds: this.state.toPersonIds,
            attachments: this.state.data.record.attachments,
        }).then((data) => {
            if (data.status === -1) window.location.href = "/login";
            this.state.innerStatus = data.innerStatus;
            if (data.status === 1) {
                this.showSuccessMessage("ارجاع نامه با موفقیت انجام پذیرفت");
                if (this.state.refreshCallerAfterSave)
                    this.state.caller.refreshData();
                this.closeMe();
            } else {
                this.showErorrMessage(data.message);
                this.setState({
                    loading: false,
                });
            }
        });
    }
    setNeedReply(e) {
        this.state.data.record.needReply = (e.target.value === "1");
        this.setState({ data: this.state.data });
    }
    pickAttachmentFile() {
        document.getElementById('attachFilePicker').click();
    }
    uploadAttachment(_file) {
        var th = this;
        this.lockScreen();
        this.getBase64(_file).then(file => {
            var pic = file;
            var picFileName = _file.name;

            th.httpPost("api/v1/letter/upload", {
                pic,
                picFileName,
            })
                .then(data => {
                    if (data.status === -1) window.location.href = "/login";
                    if (data.status === 1) {
                        th.setAttachmentValue(data.record);
                        document.getElementById('attachFilePicker').value = null;
                    }
                    else {
                        th.showErorrMessage(data.message);
                    }
                    th.setState({
                        loading: false
                    });
                });
        });
    }
    removeAttachment(id) {
        var temp = [];
        this.state.data.record.attachments.forEach(f => {
            if (f.id !== id) {
                temp.push(f);
            }
        });
        this.state.data.record.attachments = temp;
        this.setState({ data: this.state.data });
    }
    setAttachmentValue(record) {
        this.state.data.record.attachments.push(record);
        this.setState({ data: this.state.data });
    }
    getLetterCaption() {
        if (this.state.source === 2) return "درخواست مرخصی";
        if (this.state.source === 3) {
            if (this.state.formType === 1) return "درخواست اضافه کاری";
            if (this.state.formType === 2) return "درخواست ماموریت";
            if (this.state.formType === 3) return "درخواست مساعده حقوق";
        }
        return "نامه";
    }
    hasPermission(p) {
        return this.state.data.record.permissions.includes("[" + p + "]");
    }
    requestFrom(direction) {
        if (this.state.data.record.type === 1) return "letter_internal_" + direction;
        if (this.state.data.record.type === 2) return "letter_out_" + direction;
        if (this.state.data.record.type === 3) return "letter_in_" + direction;
        return "";
    }
    renderForm() {
        return <div className="modal fade listModal in show" tabIndex="-1" role="dialog">
            <div className="modal-backdrop fade in" style={{ height: "100%" }} onClick={(e) => this.closeMe()}></div>
            <div className="modal-dialog ui-draggable" style={{ minWidth: "90%" }}>
                <div className="modal-content">
                    <div className="modal-body" style={{ padding: "0" }}>
                        <input id="attachFilePicker" type="file" className="hidden" onChange={(e) => { this.uploadAttachment(e.target.files[0]) }} />
                        <div className="modal-header modal-header-info">
                            <button type="button" className="close" onClick={(e) => this.closeMe()} aria-label="Close">
                                <span aria-hidden="true">×</span>
                            </button>
                            <h4 className="modal-title">
                                {this.state.data.record.id != this.defaultGuid() ? "مشاهده " + this.getLetterCaption() : "ارسال " + this.getLetterCaption()}
                            </h4>
                        </div>
                        <div className="modal-body">
                            <div className="container-fluid">
                                <ul className="nav nav-tabs mt-n3">
                                    <li className="nav-item">
                                        <a id="letterInfoTab" className="nav-link active" data-bs-toggle="tab" href="#info"><em className="icon ni ni-info"></em><span>محتوای نامه</span></a>
                                    </li>
                                    <li className="nav-item">
                                        <a className="nav-link" data-bs-toggle="tab" href="#attachment"><em className="icon ni ni-info"></em><span>پیوستها</span></a>
                                    </li>
                                    {this.state.data.record.status !== -1 && <li className="nav-item">
                                        <a className="nav-link" data-bs-toggle="tab" href="#asign"><em className="icon ni ni-info"></em><span>ارجاعات</span></a>
                                    </li>}
                                </ul>
                                <div className="tab-content">
                                    <div className="tab-pane active" id="info">
                                        <div className="row">
                                            {this.hasPermission("new") && this.state.data.record.id === this.getDefaultGuid() && <div className="col-sm-2">
                                                <div className="form-group">
                                                    <label for="name" className="title1">اندیکاتور:</label>
                                                    <select
                                                        className="form-control"
                                                        type="text"
                                                        value={this.state.data.record.andikatorId}
                                                        onChange={(e) => this.setAndikator(e.target.value)}>
                                                        <option value={this.getDefaultGuid()}>انتخاب کنید</option>
                                                        {this.state.andikators.map((p) => <option value={p.value}>{p.label}</option>)}
                                                    </select>
                                                </div>
                                            </div>}
                                            {this.state.data.record.id === this.getDefaultGuid() ?
                                                this.state.data.record.andikatorId != this.getDefaultGuid() && <div className="col-sm-2">
                                                    <div className="form-group">
                                                        <label for="name" className="title1">شماره:</label>
                                                        <div style={{ "display": "flex", "flex-direction": "row-reverse", "align-items": "center", "gap": "5px", "border": "solid 1px #dbdfea", "border-radius": "4px", "padding": "0 10px"}}>
                                                            <label className="ltr">{this.state.data.record.andikatorPrefix}</label>
                                                            <input
                                                                defaultValue={this.state.data.record.number}
                                                                autocomplete="off"
                                                                type="text"
                                                                style={{
                                                                    "border-width": "0px 1px 0px 1px", "text-align": "center", "border-radius": "0", "background-color": "wheat"
                                                                }}
                                                                className="form-control input-sm"
                                                                onChange={(e) => this.state.data.record.number = e.target.value}
                                                            />
                                                            <label className="ltr">{this.state.data.record.andikatorPostfix}</label>
                                                        </div>
                                                    </div>
                                                </div>
                                                :
                                                <div className="col-sm-2">
                                                    <div className="form-group">
                                                        <label for="name" className="title1">شماره :</label>
                                                        <div>
                                                            {this.hasPermission("owner") && <input
                                                                defaultValue={this.state.data.record.fullNumber}
                                                                readOnly={true}
                                                                autocomplete="off"
                                                                type="text"
                                                                className="form-control input-sm"
                                                            />}
                                                            {!this.hasPermission("owner") && <p className="ltr" style={{ "text-align": "right" }}>{this.state.data.record.fullNumber}</p>}
                                                        </div>
                                                    </div>
                                                </div>}
                                            <div className="col-sm-8">
                                                <div className="form-group">
                                                    <label for="name" className="title1">
                                                        موضوع :
                                                    </label>
                                                    {this.hasPermission("owner") && <input
                                                        defaultValue={this.state.data.record.subject}
                                                        autocomplete="off"
                                                        onChange={(e) =>

                                                            (this.state.data.record.subject = e.target.value)
                                                        }
                                                        type="text"
                                                        className="form-control input-sm"
                                                    />}
                                                    {!this.hasPermission("owner") && <p>{this.state.data.record.subject}</p>}
                                                </div>
                                            </div>
                                        </div>
                                        <div className="row">
                                            {this.state.data.record.type !== 1 && this.hasPermission("owner") && <div className="col-sm-3">
                                                <div className="form-group">
                                                    <label for="name" className="title1">فرستنده :</label>
                                                    <SelectAsync
                                                        style={{ width: "100%" }}
                                                        defaultValue={
                                                            this.state.data.record.fromPersonId !=
                                                                this.getDefaultGuid()
                                                                ? [
                                                                    {
                                                                        value: this.state.data.record.fromPersonId,
                                                                        label:
                                                                            this.state.data.record.fromPersonString,
                                                                    },
                                                                ]
                                                                : null
                                                        }
                                                        isMulti={false}
                                                        placeholder="انتخاب فرستنده نامه"
                                                        defaultOptions
                                                        loadOptions={(inputValue, callback) => this.loadPersonsOptions(inputValue, callback, 0, 0, 0, this.requestFrom("from"), '',false)}
                                                        onChange={(e) => this.setFromPerson(e)}
                                                    />
                                                </div>
                                            </div>}
                                            {!this.hasPermission("owner") && <div className="col-sm-3">
                                                <div className="form-group">
                                                    <label for="name" className="title1">فرستنده :</label>
                                                    <p><b>{this.state.data.record.fromPersonString}</b></p>
                                                </div>
                                            </div>}
                                            <div className="col-sm-3">
                                                <div className="form-group">
                                                    <label for="name" className="title1">
                                                        گیرنده:
                                                    </label>
                                                    {this.hasPermission("owner") && <SelectAsync
                                                        style={{ width: "100%" }}
                                                        defaultValue={
                                                            this.state.data.record.toPersonId !=
                                                                this.getDefaultGuid()
                                                                ? [
                                                                    {
                                                                        value: this.state.data.record.toPersonId,
                                                                        label:
                                                                            this.state.data.record.toPersonString,
                                                                    },
                                                                ]
                                                                : null
                                                        }
                                                        isMulti={false}
                                                        placeholder="انتخاب گیرنده نامه"
                                                        defaultOptions
                                                        loadOptions={(inputValue, callback) => this.loadPersonsOptions(inputValue, callback, 0, 0, 0, this.requestFrom("to"), '', false)}
                                                        onChange={(e) => this.setToPerson(e)}
                                                    />}
                                                    {!this.hasPermission("owner") && <p><b>{this.state.data.record.toPersonString}</b></p>}
                                                </div>
                                            </div>
                                            {1 === 2 && <div className="col-sm-3">
                                                <div className="form-group">
                                                    <label for="name" className="title1">
                                                        امضا کننده:
                                                    </label>
                                                    {this.hasPermission("owner") && <SelectAsync
                                                        style={{ width: "100%" }}
                                                        defaultValue={
                                                            this.state.data.record.signPersonId !=
                                                                this.getDefaultGuid()
                                                                ? [
                                                                    {
                                                                        value: this.state.data.record.signPersonId,
                                                                        label:
                                                                            this.state.data.record.signPersonString,
                                                                    },
                                                                ]
                                                                : null
                                                        }
                                                        isMulti={false}
                                                        placeholder="انتخاب امضا کننده نامه"
                                                        defaultOptions
                                                        loadOptions={(inputValue, callback) => this.loadPersonsOptions(inputValue, callback, 0, 0, 0, this.requestFrom("to"), '', false)}
                                                        onChange={(e) => this.setSignPerson(e)}
                                                    />}
                                                    {!this.hasPermission("owner") && <p><b>{this.state.data.record.signPersonString}</b></p>}
                                                </div>
                                            </div>}
                                            <div className="col-sm-1">
                                                <div className="form-group">
                                                    <label for="name" className="title1">تاریخ :</label>
                                                    <div>
                                                        {this.hasPermission("owner") && <DatePicker
                                                            inputReadOnly={false}
                                                            className="form-control persian-date ltr"
                                                            placeholder={"تاریخ"}
                                                            isGregorian={false}
                                                            showTodayButton={true}
                                                            timePicker={false}
                                                            onChange={(e) => { this.state.data.record.date = e }}
                                                            value={this.getFormatedDateForDatePicker(this.state.data.record.date)}
                                                        />}
                                                        {!this.hasPermission("owner") && <b>{this.state.data.record.dateString}</b>}
                                                    </div>
                                                </div>
                                            </div>
                                            {(this.state.data.record.type === 2 || this.state.data.record.type === 3) && <div className="col-sm-2">
                                                <div className="form-group">
                                                    {this.state.data.record.type === 2 && <label for="name" className="title1">نحوه ارسال:</label>}
                                                    {this.state.data.record.type === 3 && <label for="name" className="title1">نحوه دریافت:</label>}
                                                    {this.hasPermission("owner") && <select
                                                        className="form-control"
                                                        type="text"
                                                        defaultValue={this.state.data.record.channel}
                                                        onChange={(e) => this.state.data.record.channel = parseInt(e.target.value)}>
                                                        <option value="0">انتخاب کنید</option>
                                                        <option value="1">فکس</option>
                                                        <option value="2">کاغذی</option>
                                                        <option value="3">ECE</option>
                                                    </select>}
                                                    {!this.hasPermission("owner") && <p>
                                                        {this.state.data.record.channel === 1 && "فکس"}
                                                        {this.state.data.record.channel === 2 && "کاغذی"}
                                                        {this.state.data.record.channel === 3 && "ECE"}
                                                    </p>}
                                                </div>
                                            </div>}
                                            {(this.state.data.record.type === 1 && this.state.source === 1) && <div className="col-lg-2">
                                                <div className="form-group">
                                                    <label className="title1">نیاز به پاسخ دهی:</label>
                                                    {this.hasPermission("owner") && <select
                                                        className="form-control"
                                                        type="text"
                                                        defaultValue={this.state.data.record.needReply ? "1" : "0"}
                                                        onChange={(e) => this.setNeedReply(e)}>
                                                        <option value="0">خیر</option>
                                                        <option value="1">بله</option>
                                                    </select>}
                                                    {!this.hasPermission("owner") && <p>
                                                        {this.state.data.record.needReply ? "دارد" : "ندارد"}
                                                    </p>}
                                                </div>
                                            </div>}
                                            {(this.state.data.record.type === 1 && this.state.data.record.needReply) && <div className="col-lg-2">
                                                <div className="form-group">
                                                    <label className="title1">مهلت پاسخ دهی:</label>
                                                    <div>
                                                        {this.hasPermission("owner") && <DatePicker
                                                            inputReadOnly={false}
                                                            className="form-control persian-date ltr"
                                                            placeholder={"مهلت پاسخ"}
                                                            isGregorian={false}
                                                            showTodayButton={true}
                                                            timePicker={false}
                                                            onChange={(e) => { this.state.data.record.replyDeadline = e }}
                                                            value={this.getFormatedDateForDatePicker(this.state.data.record.replyDeadline)}
                                                        />}
                                                        {!this.hasPermission("owner") && <b>{this.state.data.record.replyDeadlineString}</b>}
                                                    </div>
                                                </div>
                                            </div>}
                                        </div>
                                        <div className="row">
                                            <div className="col-sm-12">
                                                <div className="form-group">
                                                    {this.state.source === 2 ?
                                                        <label className="title1">علت درخواست مرخصی :</label>
                                                        :
                                                        (this.state.source === 3 && this.state.formType === 2) ?
                                                            <label className="title1"> علت ماموریت :</label>
                                                            :
                                                            <label className="title1">متن :</label>
                                                    }
                                                    {this.hasPermission("owner") && <textarea
                                                        defaultValue={this.state.data.record.content}
                                                        autocomplete="off"
                                                        style={{ "min-height": "120px" }}
                                                        onChange={(e) =>

                                                            (this.state.data.record.content = e.target.value)
                                                        }
                                                        type="text"
                                                        className="form-control input-sm"
                                                    ></textarea>}
                                                    {!this.hasPermission("owner") && <div dangerouslySetInnerHTML={{ __html: this.state.data.record.content.replaceAll('\n', '<br/>') }}></div>}
                                                </div>
                                            </div>
                                        </div>
                                        <div className="row">
                                            <div className="col-sm-12">
                                                <div className="form-group">
                                                    <label for="name" className="title1">
                                                        رونوشتها:
                                                    </label>
                                                    {this.hasPermission("owner") && <SelectAsync
                                                        style={{ width: "100%" }}
                                                        defaultValue={
                                                            this.state.data.record.transcriptRecipients
                                                        }
                                                        isMulti={true}
                                                        placeholder="انتخاب رونوشتهای نامه"
                                                        defaultOptions
                                                        loadOptions={(inputValue, callback) => this.loadPersonsOptions(inputValue, callback, 0, 0, 0, this.requestFrom("to"), '', false)}
                                                        onChange={(e) => this.setTranscriptRecipients(e)}
                                                    />}
                                                    {!this.hasPermission("owner") && <div>{this.state.data.record.transcriptRecipients.map(f =>
                                                        <span style={{ "background-color": "#dbdfea", "padding": "0 5px", "margin-left": "5px", "border-radius": "5px", "margin-bottom": "15px", "display": "inline-block" }}>{f.label}</span>
                                                    )}</div>}
                                                </div>
                                            </div>
                                        </div>
                                        {(this.hasPermission("owner")) && this.getFieldVisable("note") && <div className="row">
                                            <div className="col-sm-12">
                                                <div className="form-group">
                                                    <label for="name" className="title1">یادداشت: </label>
                                                    <textarea
                                                        defaultValue={this.state.data.record.note}
                                                        autocomplete="off"
                                                        style={{ "min-height": "40px" }}
                                                        onChange={(e) => this.state.data.record.note = e.target.value}
                                                        type="text"
                                                        className="form-control input-sm"></textarea>
                                                </div>
                                            </div>
                                        </div>}
                                        {this.hasPermission("response") && <div className="col-sm-12">
                                            <div className="form-group">
                                                <label for="name" className="title1">
                                                    ارجاع/پاسخ به:
                                                </label>
                                                <SelectAsync
                                                    style={{ width: "100%" }}
                                                    defaultValue={this.state.toPersonIds}
                                                    isMulti={true}
                                                    placeholder="انتخاب ارجاع/پاسخ نامه"
                                                    defaultOptions
                                                    loadOptions={(inputValue, callback) => this.loadPersonsOptions(inputValue, callback, 0, 0, 0, this.requestFrom("to"), '', false)}
                                                    onChange={(e) => this.state.toPersonIds = e}
                                                />
                                            </div>
                                        </div>}
                                        {this.hasPermission("response") && <div className="row">
                                            <div className="col-sm-12">
                                                <div className="form-group">
                                                    <label for="name" className="title1">
                                                        متن پاسخ/ارجاع :
                                                    </label>
                                                    <textarea
                                                        defaultValue={this.state.content}
                                                        autocomplete="off"
                                                        style={{ "min-height": "120px" }}
                                                        onChange={(e) =>

                                                            (this.state.content = e.target.value)
                                                        }
                                                        type="text"
                                                        className="form-control input-sm"
                                                    ></textarea>
                                                </div>
                                            </div>
                                        </div>}
                                        {this.hasPermission("response") && <div className="row">
                                            <div className="col-sm-12">
                                                <div className="form-group">
                                                    <label for="name" className="title1">
                                                        یادداشت :
                                                    </label>
                                                    <textarea
                                                        defaultValue={this.state.note}
                                                        autocomplete="off"
                                                        style={{ "min-height": "40px" }}
                                                        onChange={(e) =>

                                                            (this.state.note = e.target.value)
                                                        }
                                                        type="text"
                                                        className="form-control input-sm"
                                                    ></textarea>
                                                </div>
                                            </div>
                                        </div>}
                                        {this.state.source === 2 && <Leave Caller={this} />}
                                        {this.state.source === 3 && <Form UiSettings={this.state.uiSettings} Type={this.state.formType} Caller={this} />}
                                    </div>
                                    <div className="tab-pane" id="attachment">
                                        <table className="table table-bordered acc_grid_row">
                                            <thead>
                                                <tr className="active">
                                                    <td style={{ "width": "75px" }}>حجم فایل</td>
                                                    <td style={{ "width": "75px" }}>فرمت فایل</td>
                                                    <td style={{ "width": "75px" }}>مشاهده پیوست</td>
                                                    {(this.hasPermission("owner") || this.hasPermission("response")) && this.state.data.record.status === -1 && <td style={{ "width": "35px" }}></td>}
                                                </tr>
                                            </thead>
                                            <tbody>
                                                {this.state.data.record.attachments.map((item, index) =>
                                                    <tr key={item.id}>
                                                        <td>{this.FixedPointNumber((item.size / 1024), 2)} کیلوبایت</td>
                                                        <td>{item.format}</td>
                                                        <td>
                                                            <a href={"/api/v1/media/secretariat/attachment/view/?file=" + item.fileName} target="_blank" className="me-1 text-primary hand" style={{ "display": "inline-block" }}>مشاهده</a>
                                                        </td>
                                                        {(this.hasPermission("owner") || this.hasPermission("response")) && this.state.data.record.status === -1 && <td>
                                                            <span title="حذف سطر" onClick={e => this.removeAttachment(item.id)} className="fa fa-trash fa-fw close-grid-row"></span>
                                                        </td>}
                                                    </tr>
                                                )}
                                                <tr>
                                                    <td colspan="4">
                                                        <a className="my-2 btn btn-primary hand" onClick={e => this.pickAttachmentFile()} style={{ "display": "inline-block" }}>افزودن فایل پیوست</a>
                                                    </td>
                                                </tr>
                                            </tbody>
                                        </table>
                                    </div>
                                    <div className="tab-pane" id="asign">
                                        <table className="table table-bordered acc_grid_row">
                                            <thead>
                                                <tr className="active">
                                                    <td style={{ "width": "100px" }}>فرستنده</td>
                                                    <td style={{ "width": "100px" }}>گیرنده</td>
                                                    <td style={{ "width": "70px" }}>تاریخ</td>
                                                    <td style={{ "width": "60px" }}>ساعت</td>
                                                    <td>متن</td>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                {this.state.data.record.assignments.map((item, index) =>
                                                    <tr key={item.id}>
                                                        <td>{item.fromPersonName}</td>
                                                        <td>{item.toPersonName}</td>
                                                        <td>{item.dateString}</td>
                                                        <td>{item.timeString}</td>
                                                        <td>{item.content}</td>
                                                    </tr>
                                                )}
                                            </tbody>
                                        </table>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="modal-footer">
                            <button type="button" className="btn btn-default btn-smoke" onClick={(e) => this.closeMe()} >
                                انصراف
                            </button>
                            {this.state.source !== 2 && this.state.source !== 3 && this.hasPermission("owner") && this.state.data.record.status === -1 && <button type="submit" name="bank_form_modal_submit" className="btn btn-success" onClick={(e) => this.save(e, -1)}>
                                ذخیره
                            </button>}
                            {this.hasPermission("owner") && this.state.data.record.status === -1 && <button type="submit" name="bank_form_modal_submit" className="btn btn-success" onClick={(e) => this.save(e, 0)}>
                                ذخیره و ارسال
                            </button>}
                            {this.hasPermission("response") && <button type="submit" className="btn btn-success" onClick={(e) => this.asign(e)}>
                                ارجاع/پاسخ
                            </button>}
                            {!this.state.data.record.signed && this.state.data.record.isSignerUser && <button type="submit" className="btn btn-danger" onClick={(e) => this.sign(e)}>
                                امضا
                            </button>}
                        </div>
                    </div>
                </div>
            </div>
        </div>
    }
    render() {
        if (!this.isBlank(this.state.redirect))
            return <Navigate to={this.state.redirect} />;

        let contents = this.state.loading
            ? this.renderLoading()
            : [
                this.state.lockScreen === 1 && this.lockScreen(),
                this.getGlobalContainer(),
                this.renderForm(),
            ];

        return contents;
    }
}